module.exports = __webpack_public_path__ + "img/환전요청.9e62facb.png";